import { useEffect } from 'react';
import { useLDClient } from 'launchdarkly-react-client-sdk';

import { useAppSelector } from 'features/app/hooks';
import { agentNumberSelector } from 'features/user/store';
import { ModeStorageService } from 'features/multi-mode/services';
import { LoggerService } from 'features/logger/services';

const IdentifyOnUserChange = () => {
  const ldClient = useLDClient();
  const agentNumber = useAppSelector(agentNumberSelector);

  useEffect(() => {
    if (!ldClient) return;

    const wantsAllModes = localStorage.getItem(
      'launchDarklyContext/wantsAllModes'
    );

    // Normalize `agentNumber` into a string key and validate it's non-empty.
    const keyString =
      agentNumber === undefined || agentNumber === null
        ? ''
        : String(agentNumber).trim();
    const hasKey = keyString.length > 0;

    const context: any = {
      kind: 'user',
      // Set anonymous true when we have no key to avoid invalid context
      anonymous: !hasKey,
      // Only include `key` when we have a validated non-empty key string
      ...(hasKey ? { key: keyString, agentNumber } : undefined),
      ...(wantsAllModes === null ? undefined : { wantsAllModes }),
      ...(ModeStorageService.getMode()
        ? { mode: ModeStorageService.getMode() }
        : undefined),
    };

    ldClient.identify(context).catch((err: unknown) => {
      LoggerService.error(err);
    });
  }, [ldClient, agentNumber]);

  return null;
};

export default IdentifyOnUserChange;
